import { DomainEntity, SgvId, SgvJson } from '@eceos/arch';

export class CFOP implements DomainEntity {
  constructor(
    readonly id = SgvId.gen(),
    readonly name = '',
    readonly number = '',
    readonly isSt = false,
    readonly isTransport = false
  ) {}

  get nameWithNumber(): string {
    return this.number + " - " + this.name;
  }

  toJson() {
    return SgvJson.to.simple(this);
  }

  static fromJson(json: any): CFOP {
    return SgvJson.from.simple(json, CFOP);
  }
}
